import React, { useEffect, useState } from "react";
import { useAppDispatch, useAppSelector } from "hooks/storeHooks";
import { dashboardActions } from "redux/Ldb/actions";
import moment from "moment";
import useInfiniteScroll from "hooks/useInfinteScroll";

const useGetDashboardConfigList = () => {
    const dispatch = useAppDispatch();
    const [configTableData, setConfigTableData] = useState<{ [key: string]: any }[]>([]);
    const [productId, setProductId] = useState<string>("");
    const [channel, setChannel] = useState<string>("");
    const [category, setCategory] = useState<string>("");
    const [dateRange, setDateRange] = useState<any>("yearly");
    const [endDate, setEndDate] = useState<string>("");
    const [startDate, setStartDate] = useState<any>("");
    const [pagination, setPagination] = useState<{ currentPage: string; noOfPages: string }>({
        currentPage: "1",
        noOfPages: "",
    });

    const { updatedLimit, isLoadingMore, setLoadMore, updatedPage, setUpdatedPage } =
        useInfiniteScroll(
            { current: pagination.currentPage, number_of_pages: pagination.noOfPages },
            10
        );

    const handleCategoryChange = (value) => {
        setCategory(value);
    };

    const handleChannelChange = (value) => {
        setChannel(value);
    };
    const handleProductChange = (value) => {
        setProductId(value);
    };
    const handleDateRangeChange = (period) => {
        setDateRange(period);
        // setStartDate("");
        // setEndDate("");
    };
    // const handleStartAndEndDateChange = (customDate) => {
    //     setStartDate(customDate[0].toISOString());
    //     setEndDate(customDate[1].toISOString());
    //     setDateRange("custom");
    // };

    const {
        fetchingDashboardConfigList,
        fetchedDashboardConfigListSuccess,
        fetchedDashboardConfigListFailure,
    } = useAppSelector((state) => state.dashboard);

    useEffect(() => {
        if (Boolean(fetchedDashboardConfigListSuccess)) {
            // console.log("fetchedDashboardConfigListSuccess", fetchedDashboardConfigListSuccess);
            setConfigTableData(fetchedDashboardConfigListSuccess?.inventories);
            setPagination({
                currentPage: fetchedDashboardConfigListSuccess?.pagination?.current,
                noOfPages: fetchedDashboardConfigListSuccess?.pagination?.number_of_pages,
            });
        }
    }, [fetchedDashboardConfigListSuccess]);

    useEffect(() => {
        dispatch(
            dashboardActions?.getDashboardConfigList(
                updatedPage,
                dateRange,
                productId,
                channel,
                category
            )
        );
    }, [dispatch, updatedPage, dateRange, productId, channel, category]);

    return {
        data: configTableData,
        isFetching: fetchingDashboardConfigList,
        error: fetchedDashboardConfigListFailure,
        handleCategoryChange,
        handleProductChange,
        updatedPage,
        setUpdatedPage,
        pagination,
        setPagination,
        handleDateRangeChange,
        handleChannelChange,
    };
};

export default useGetDashboardConfigList;
